export { default as Img200 } from './processed/200/placeholder.jpg';
export { default as Img400 } from './processed/400/placeholder.jpg';
export { default as Img600 } from './processed/600/placeholder.jpg';
export { default as Imgthumb } from './processed/thumb/placeholder.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/placeholder.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/placeholder.jpg';
export const ImgData = { width: 488, height: 366, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      124,
      124,
      124
    ],
    "_population": 1,
    "_hsl": [
      0,
      0,
      0.48627450980392156
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      188,
      188
    ],
    "_population": 9,
    "_hsl": [
      0,
      0,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      76,
      76
    ],
    "_population": 1,
    "_hsl": [
      0,
      0,
      0.2980392156862745
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/placeholder.js